// Updated generators to enforce WS over TLS for Cloudflare
export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const generateVless = (data) => {
  const { uuid, address, port, host, path, name } = data;
  const params = new URLSearchParams();
  params.append('encryption', 'none');
  params.append('security', 'tls');
  params.append('type', 'ws');
  params.append('sni', host); // SNI must be your pages.dev domain
  params.append('host', host);
  params.append('path', path || '/');
  params.append('fp', 'chrome');
  
  return `vless://${uuid}@${address}:${port}?${params.toString()}#${encodeURIComponent(name)}`;
};

export const generateVmess = (data) => {
  const { uuid, address, port, host, path, name } = data;
  const config = {
    v: "2",
    ps: name,
    add: address,
    port: port,
    id: uuid,
    aid: "0",
    scy: "auto",
    net: "ws",
    type: "none",
    host: host,
    path: path || "/",
    tls: "tls",
    sni: host
  };
  return `vmess://${btoa(JSON.stringify(config))}`;
};

export const generateHapp = (data) => {
  const { uuid, address, port, host, path, name } = data;
  const config = {
    p: "vless",
    a: address,
    po: port,
    id: uuid,
    n: "ws",
    s: "tls",
    h: host,
    pa: path,
    sn: host,
    rm: name
  };
  const encoded = btoa(JSON.stringify(config).split('').reverse().join(''));
  return `happ://crypt5${encoded}`;
};